import React from "react";
import { useLocation } from "react-router-dom";
import { NAVLIST_CATEGORY } from "../pages/HrDocumentsSociety/HrDocumentsSocietyOutlet";

const useLogicDocumentHrOutlet = () => {
    const location = useLocation();

    const isActiveFolderHr = location.pathname.includes(
        NAVLIST_CATEGORY.hr_document
    );
    const isActiveExpenses = location.pathname.includes(
        NAVLIST_CATEGORY.expenses
    );
    const isActiveCommonDocuments = location.pathname.includes(
        NAVLIST_CATEGORY.common_documents
    );
    const isActiveLeave = location.pathname.includes(
        NAVLIST_CATEGORY.leave_proof
    );
    const isActiveTimesheet = location.pathname.includes(
        NAVLIST_CATEGORY.time_reporting
    );
    const isAnyActive =
        isActiveFolderHr ||
        isActiveExpenses ||
        isActiveCommonDocuments ||
        isActiveLeave ||
        isActiveTimesheet;
    return {
        isActiveFolderHr: isActiveFolderHr || !isAnyActive,
        isActiveExpenses,
        isActiveCommonDocuments,
        isActiveLeave,
        isActiveTimesheet,
    };
};

export default useLogicDocumentHrOutlet;
